export var INFO_MENU_WIDTH = {
  xs: 180,
  md: 200,
  xl: 220
};